import {Icon} from 'components/atoms/Media/Icon';
import {useMetaStore, selectEpiEditUrl} from 'features/meta/store/useMetaStore';
import React, {useState} from 'react';


interface Props {
    id: string;
}

export const CopyButton: React.FunctionComponent<Props> = ({ id}) => {

    const epiEditUrl = useMetaStore(selectEpiEditUrl);
    const [copied, setCopied] = useState<boolean>(false);

    if(epiEditUrl === '') return null;

    const copyId = async () => {
        setCopied(true);

        await copyFunction(`#${id}`);

        setTimeout(() => {
            setCopied(false);
        }, 1000)
    };

    const copyFunction = (textToCopy: string) => {
        // navigator clipboard api needs a secure context (https)
        if (navigator.clipboard && window.isSecureContext) {
            return navigator.clipboard.writeText(textToCopy);
        } else {
            // text area method
            const textArea = document.createElement("textarea");
            textArea.value = textToCopy;
            // make the textarea out of viewport
            textArea.style.position = "fixed";
            textArea.style.left = "-999999px";
            textArea.style.top = "-999999px";
            document.body.appendChild(textArea);
            textArea.focus();
            textArea.select();
            return new Promise<void>((res, rej) => {
                if (document.execCommand('copy')) { res(); } else { rej(); }
                textArea.remove();
            });
        }
    };

    return (
        <div className="content-area__copy-container no-text-select">
            <div className="content-area__copy-button" onClick={copyId}>
                <span>Copy block id</span>
                <Icon name="documents" />

                {copied &&
                <div className="content-area__copied-text">
                    Copied to clipboard
                </div>
                }
            </div>

        </div>
    )
};

